import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button, Row, Col, Alert, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

import { getSetupInfo } from "../../actions";
import Layout from "../layout";
import ErrorModal from "../error/ErrorModal";
import Loading from "../loading";

class Admin extends Component {
  state = {
    vcSearch: "",
    vcRows: {},
  };

  componentDidMount = async () => {
    if (!this.props.setupTimes) await this.props.getSetupInfo();
  };

  onInputChange = (e) => {
    this.setState({ vcSearch: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { vcSearch } = this.state;
    if (vcSearch) {
      let vcRows = { ...this.state.vcRows };
      this.props.setupTimes.forEach((time) => {
        if (!time.VoteCenter.toLowerCase().includes(vcSearch.toLowerCase())) {
          const vcid = time.VCID;
          vcRows[vcid] = true;
        }
      });
      this.setState({ vcRows });
    }
  };

  resetSearch = () => {
    this.setState({ vcRows: {}, vcSearch: "" });
  };

  createSearch() {
    return (
      <Form onSubmit={this.onSubmit} className="mb-3 float-left" inline>
        <Form.Label htmlFor="vcSearchInput" className="mb-3">
          Search by name:&nbsp;
        </Form.Label>
        <Form.Control
          id="vcSearchInput"
          placeholder="Vote Center Name"
          onChange={this.onInputChange}
          value={this.state.vcSearch}
          className="mr-sm-4 mb-3"
        />
        <Button type="submit" className="mr-sm-2 mb-3 mx-auto">
          Submit
        </Button>
        <Button
          onClick={this.resetSearch}
          variant="danger"
          className="mb-3 mx-auto"
        >
          Reset
        </Button>
      </Form>
    );
  }

  createTable() {
    return (
      <Table responsive striped>
        <thead>
          <tr>
            <th>VCID</th>
            <th>Area</th>
            <th>City</th>
            <th>Vote Center</th>
            <th>Address</th>
            <th>Setup Time</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {this.props.setupTimes.map((row) => {
            const showRow = this.state.vcRows[row.VCID] ? "d-none" : "";
            return (
              <tr key={row.VCID} className={showRow}>
                <td>{row.VCID}</td>
                <td>{row.Area}</td>
                <td>{row.City}</td>
                <td>{row.VoteCenter}</td>
                <td>{row.VIGAddress}</td>
                <td>{row.SetUpTimeForPass}</td>
                <td>
                  <Button
                    as={Link}
                    to={`/admin/edit/${row.VCID}`}
                    size="sm"
                    variant="info"
                  >
                    Edit Info
                  </Button>
                </td>
                <td>
                  <Button
                    as={Link}
                    to={`/admin/delete/${row.VCID}`}
                    size="sm"
                    variant="danger"
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  renderContent() {
    if (this.props.setupTimes) {
      const rows = this.props.setupTimes;
      if (!Array.isArray(rows)) {
        return <ErrorModal />;
      } else {
        return (
          <>
            <Row>
              <Col sm className="mb-3">
                <h3>Add a Vote Center</h3>
                <br />
                <Button
                  as={Link}
                  to="/admin/add"
                  alt="Add a new Vote Center"
                  className="mb-4"
                >
                  Add New Vote Center
                </Button>{" "}
              </Col>
            </Row>
            <Row>
              <Col>
                <h3>Edit and Delete Existing Vote Centers</h3>
                <br />
                {rows.length > 0 && this.createSearch()}
              </Col>
            </Row>
            <br />
            {rows.length > 0 && this.createTable()}
            {!rows.length && (
              <Alert variant="info" className="text-center">
                No Vote Center information found. Click Add New Vote Center to
                get started.
              </Alert>
            )}
          </>
        );
      }
    } else {
      return <Loading />;
    }
  }

  render() {
    return <Layout title="Setup Times">{this.renderContent()}</Layout>;
  }
}

const mapStateToProps = (state) => {
  return { auth: state.auth, setupTimes: state.admin.setupTimes };
};

export default connect(mapStateToProps, { getSetupInfo })(Admin);
